import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { Api } from "../lib/api";

export default function StoriesPage() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    Api.stories().then(setStories).catch(() => setStories([]));
  }, []);

  return (
    <div className="container-x py-12 md:py-20" data-testid="stories-page">
      <p className="eyebrow">From the island</p>
      <h1 className="heading-xl mt-2">
        Stories from <span className="italic-accent">Grinda.</span>
      </h1>
      <p className="body-lead mt-3 max-w-xl">
        Behind-the-scenes journals, day-of details and what&apos;s coming up on the lawn.
      </p>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {stories.map((s) => (
          <article key={s.id} className="card overflow-hidden" data-testid={`story-${s.id}`}>
            {s.image_url && (
              <img src={s.image_url} alt={s.title} className="w-full h-48 object-cover" />
            )}
            <div className="p-5">
              <p className="text-xs text-grey flex items-center gap-1">
                <Calendar size={12} />
                {new Date(s.published_at).toLocaleDateString("en", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </p>
              <h2 className="font-serif text-xl text-navy mt-2">{s.title}</h2>
              <p className="text-grey text-sm mt-2 line-clamp-3">{s.excerpt}</p>
            </div>
          </article>
        ))}
        {stories.length === 0 && <p className="text-grey">More stories coming soon.</p>}
      </div>
    </div>
  );
}
